<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Event/Detail</h1>
      </div>
      <div class="mr-10" v-if="this.$route.params.id === this.deployedEventId">
        <span class="text-2xl text-dark font-bold">
          Selected
        </span>
      </div>
      <div class="mr-10" v-else>
        <button
          class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-2xl bg-app-default hover:bg-app-light text-white font-bold"
          type="button"
          @click="updateDeployedEvent(this.$route.params.id)"
        >
          Select
        </button>
      </div>
    </div>

    <!-- <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Carousel Image/Video mp4 (1200 px X 500 px)
            </div>
          </div>
          <div class="flex">
            <div class="" v-if="isVideo">
              <iframe :src="dataEvent.event_carousel" />
            </div>
            <img
              v-else
              class="w-full lg:w-9/12 mr-3 h-44 lg:h-80"
              :src="dataEvent.event_carousel"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div> -->

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Products (1020 px X 1020 px)</div>
          </div>
          <div class="flex">
            <img
              
              :key="evn"
              class="w-56 h-56 mr-3"
              :src="dataEvent.event_images"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Event Info</div>
          </div>
          <div class="font-semibold">URL Video</div>
          <div v-if="dataEvent.event_carousel !== ''" class="ml-5">
            {{ dataEvent.event_carousel }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Name</div>
          <div v-if="dataEvent.event_name !== ''" class="ml-5">
            {{ dataEvent.event_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">First Title</div>
          <div v-if="dataEvent.event_first_title !== ''" class="ml-5">
            {{ dataEvent.event_first_title }}
          </div>
          <div class="font-semibold">First Description</div>
          <div v-if="dataEvent.event_first_description !== ''" class="ml-5">
            {{ dataEvent.event_first_description }}
          </div>
          <div class="font-semibold">Second Title</div>
          <div v-if="dataEvent.event_second_title !== ''" class="ml-5">
            {{ dataEvent.event_second_title }}
          </div>
          <div class="font-semibold">Second Description</div>
          <div v-if="dataEvent.event_first_description !== ''" class="ml-5">
            {{ dataEvent.event_first_description }}
          </div>
          <div class="font-semibold">Status</div>
          <div v-if="dataEvent.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div>
          <div class="font-semibold">Event Start</div>
          <div v-if="dataEvent.event_start !== null" class="ml-5">
            {{ event_start }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Event End</div>
          <div v-if="dataEvent.event_end !== null" class="ml-5">
            {{ event_end }}
          </div>
          <div v-else class="ml-5">-</div>
        </div>
      </div>
    </div>
    <Warning />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import BackButton from "../../components/BackButton.vue";
export default {
  name: "ContentDetail",
  components: {
    Warning,
    BackButton,
  },
  data() {
    return {
      dataEvent: {},
      deployedEventId: null,
      isVideo: true,
      event_start: "",
      event_end: "",
    };
  },
  methods: {
    detailEvent: async function() {
      try {
        let res = await fetch(`${API}v1/event/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go(-1);
          return;
        }
        // this.cekExtension(respon.data.event_carousel);
        this.dataEvent = respon.data;
        let stE = new Date(respon.data.event_start);
        let enE = new Date(respon.data.event_end);
        this.event_start = `${stE.getDate()}-${stE.getMonth() +
          1}-${stE.getFullYear()} ${stE.getHours()}:${stE.getMinutes()}`;
        this.event_end = `${enE.getDate()}-${enE.getMonth() +
          1}-${enE.getFullYear()} ${enE.getHours()}:${enE.getMinutes()}`;
      } catch (err) {
        this._error("internal server error");
        this.$router.go(-1);
        return;
      }
    },
    cekExtension: function(nameFile) {
      const imageFormat = ["jpg", "png", "jpeg"];
      const videoFormat = ["mp4", "3gp"];
      let regexExtension = "[^.]+$";
      let extension = nameFile.match(regexExtension);
      if (imageFormat.includes(extension[0])) {
        this.isVideo = false;
      }
      if (videoFormat.includes(extension[0])) {
        this.isVideo = true;
      }
    },
    updateDeployedEvent: async function(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      try {
        let res = await fetch(`${API}v1/admin/cms/event/displayed_event/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go(-1);
          return;
        }
        this.deployedEventId = this.$route.params.id;
      } catch (err) {
        this._error("Internal server error");
        this.$router.go(-1);
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailEvent();
    this.deployedEventId = this.$route.query.deployedEventId;
  },
};
</script>
